var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkOutlineBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0371 0 0 4.0371 0 9C0 13.9629 4.0371 18 9 18C13.9629 18 18 13.9622 18 9C18 4.0378 13.9629 0 9 0ZM9 16.6057C4.80674 16.6057 1.39426 13.194 1.39426 9C1.39426 4.80604 4.80674 1.39426 9 1.39426C13.194 1.39426 16.6057 4.80604 16.6057 9C16.6057 13.194 13.1933 16.6057 9 16.6057Z",
    fill: "#2894FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1283 5.86986C12.8446 5.61192 12.4033 5.63213 12.144 5.91725L7.89144 10.5999L5.83697 8.51132C5.56578 8.23665 5.1252 8.23246 4.85123 8.50296C4.57655 8.77275 4.57237 9.21403 4.84286 9.4887L7.41458 12.103C7.54635 12.2368 7.7248 12.3114 7.91162 12.3114C7.9158 12.3114 7.92069 12.3114 7.92487 12.3121C8.11728 12.3079 8.29855 12.2257 8.4275 12.0834L13.1757 6.85494C13.4344 6.56908 13.4134 6.1285 13.1283 5.86986Z",
    fill: "#2894FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOutlineBlue);
export default __webpack_public_path__ + "static/media/checkmark_outline_blue.c850493394f65f77cf16a0377c888f7d.svg";
export { ForwardRef as ReactComponent };